import { useMemo } from "react";

// DiceBear (https://dicebear.com) — free, no-key vector avatars served as SVG URLs.
// We store the chosen URL as the user's photo, so nothing needs to be uploaded.
const DICEBEAR = "https://api.dicebear.com/9.x";
const avatarUrl = (style, seed) =>
    `${DICEBEAR}/${style}/svg?seed=${encodeURIComponent(seed)}&backgroundColor=ff4500,141414,2196f3,22c55e,a855f7,f59e0b&radius=50`;

// ~50 avatars across a variety of DiceBear styles, all shown at once.
const SEEDS = ["Milo", "Zoe", "Max", "Luna", "Leo", "Nova", "Finn", "Ivy", "Kai", "Ruby", "Ace", "Sky"];
const STYLES = ["fun-emoji", "adventurer", "open-peeps", "bottts", "pixel-art"];

/**
 * AvatarPicker — a compact grid of ~50 selectable DiceBear avatars, all shown at
 * once (no tabs). Each avatar is sized to match the header username avatar.
 * Clicking one calls onSelect(url) with the avatar's SVG URL (no upload needed).
 */
export default function AvatarPicker({ value, onSelect }) {
    const urls = useMemo(
        () => STYLES.flatMap((style) => SEEDS.slice(0, 10).map((s) => avatarUrl(style, s))),
        []
    );

    return (
        <div data-testid="avatar-picker">
            <div className="flex flex-wrap gap-2">
                {urls.map((url) => {
                    const selected = value === url;
                    return (
                        <button
                            key={url}
                            type="button"
                            data-testid="avatar-option"
                            onClick={() => onSelect(url)}
                            title="Use this avatar"
                            className={`h-8 w-8 shrink-0 rounded-full overflow-hidden border-2 bg-[#0f0f0f] transition-colors ${
                                selected ? "border-[#ff4500]" : "border-[#2a2a2a] hover:border-[#3a3a3a]"
                            }`}
                        >
                            <img src={url} alt="Avatar option" className="h-full w-full object-cover" loading="lazy" />
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
